import { Injectable, inject } from '@angular/core';

import { TrackingService } from '@frontend/vanilla/core';

import { EventData } from '../model/gtm-event-model';
import { DataService } from './data.service';

export type TrackingData = { [key: string]: any };
@Injectable({
    providedIn: 'root',
})
export class GtmService {
    private dataService = inject(DataService);
    private trackingService = inject(TrackingService);
    gtmEventData: EventData;

    private defaulatPaymentData() {
        const sessionInfo = this.dataService.sessionInfo;
        return {
            source: 'bestlip qd',
            product: sessionInfo?.productId,
        };
    }
    loadGTMData() {
        this.gtmEventData = new EventData();
        this.gtmEventData = {
            component: {},
            payment: { ...this.defaulatPaymentData() },
        };
    }

    triggerEventWithData(eventName: any, data: any) {
        const event = eventName || data?.event;
        if (!data.payment) {
            data.payment = this.defaulatPaymentData();
        }
        this.trackingService.triggerEvent(event, data);
    }

    raiseCloseEvent() {
        const eventName = 'Event.Tracking';

        const component = {
            CategoryEvent: 'cashier',
            LabelEvent: 'high volume deposit declines - warning',
            ActionEvent: 'exit',
            PositionEvent: 'not applicable',
            LocationEvent: 'quick deposit',
            EventDetails: 'cancel link',
            URLClicked: 'not applicable',
        };

        const eventData = {
            ...this.gtmEventData,
            component,
        };

        // Trigger the event with the prepared data
        this.triggerEventWithData?.(eventName, eventData);
    }

    raiseEvent(eventName?: any, pageName?: any, paymentMethod?: any, isOnload = false) {
        const eventData: any = { ...this.gtmEventData };
        eventData.payment.method = paymentMethod;
        const response = this.dataService.data;
        if (isOnload) eventData.eventName = 'quick_deposit_pop_up_load';

        if (response) {
            if (eventName === 'deposit' && response.status === 'SUCCESS') {
                eventData.payment.txnAmount = response.amount ? response.amount.value : '';
                eventData.payment.txnCurrency = response.amount ? response.amount.currencyCode : '';
                eventData.payment.baseAmount = response.baseAmount ? response.baseAmount.value : '';
                eventData.payment.baseCurrency = response.baseAmount ? response.baseAmount.currencyCode : '';
                eventData.payment.lifeTimeDeposits = response.totalDepositCount ? response.totalDepositCount : '';
            } else if ((eventName === 'paymentError' && response.errorResponse) || pageName === 'DepositDecline') {
                eventData.payment.error = response.errorResponse ? response.errorResponse.errorMessage : '';
                eventData.payment.lifeTimeDeposits = response.totalDepositCount ? response.totalDepositCount : '';
                eventData.payment.error = response.errorResponse ? response.errorResponse.errorMessage : '';
            }
            if (eventName === 'paymentError' && response.kycCheckResponse && 'DEU' === response.kycCheckResponse.jurisdiction) {
                if (response.kycCheckResponse.productPreference === 'SPORTSBOOK') {
                    if (response.kycCheckResponse.errorResponse) {
                        if (response.kycCheckResponse.errorResponse.errorMessage === 'KYC_GRACEPERIOD_COMPLETED') {
                            eventData.payment.error = 'KYC unverified – grace period ended';
                        } else if (response.kycCheckResponse.errorResponse.errorMessage === 'KYC_LIMIT_EXCEEDED') {
                            eventData.payment.error = 'KYC unverified – 50k deposit limit amount exceeded';
                        }
                    }
                } else {
                    if (response.kycCheckResponse.errorResponse) {
                        if (response.kycCheckResponse.errorResponse.errorMessage === 'KYC_GRACEPERIOD_COMPLETED') {
                            eventData.payment.error = 'KYC unverified – grace period ended';
                        } else if (response.kycCheckResponse.errorResponse.errorMessage === 'KYC_LIMIT_EXCEEDED') {
                            eventData.payment.error = ' KYC partial verified – 150 EUR deposit limit amount exceeded';
                        }
                    }
                }
                if (
                    response.kycCheckResponse &&
                    response.kycCheckResponse.gbgVerified &&
                    response.kycCheckResponse.productPreference !== 'SPORTSBOOK'
                ) {
                    eventData.payment.error = 'KYC unverified – gaming verification required';
                }
            }
        }

        this.triggerEventWithData(eventName, eventData);
    }

    raiseEventForCDRLimitExceeded(isCDRExceeded: any, paymentMethod: any, totalDepositCount: any) {
        const eventData = {
            payment: {
                error: isCDRExceeded ? 'central deposit limits exceeds budget' : 'central deposit limits exhausted budget',
                lifeTimeDeposits: totalDepositCount || '',
                method: paymentMethod,
            },
        };
        this.triggerEventWithData('paymentError', eventData);
    }

    raiseEventForArcUnusualDeposit(eventType: any, locationEvent: any) {
        const eventData: EventData = this.getEventData();
        let eventName;
        if (eventType === 'unusualArcDepositInteractionMessage') {
            eventName = 'contentView';
            eventData.component.CategoryEvent = 'cashier';
            eventData.component.LabelEvent = 'high volume deposit declines warning';
            eventData.component.ActionEvent = 'load';
            eventData.component.PositionEvent = 'not applicable';
            eventData.component.LocationEvent = locationEvent;
            eventData.component.EventDetails = 'high volume deposit declines warning';
            eventData.component.URLClicked = 'not applicable';
        }
        this.triggerEventWithData(eventName, eventData);
    }
    // when user got any banner/toaster message loaded related to affordability
    raiseEventForAffordabilityBannerLoad(
        labelevent: any,
        eventDetails: any,
        positionEvent: any,
        level: any,
        affGroup: any,
        affAgeGroup: any,
        limitType: any,
    ) {
        const eventData = {
            eventName: 'contentView',
            component: {
                CategoryEvent: 'affordability',
                LabelEvent: labelevent,
                ActionEvent: 'load',
                PositionEvent: positionEvent,
                LocationEvent: 'quick deposit page',
                EventDetails: eventDetails,
                URLClicked: 'not applicable',
                AffordabilityJourney: level,
                AffordabilityGroups: affGroup?.toLowerCase(),
                AffAgeGroups: affAgeGroup?.toLowerCase(),
                AffLimitType: limitType,
            },
        };
        !affGroup ? delete eventData.component.AffordabilityGroups : null;
        !affAgeGroup ? delete eventData.component.AffAgeGroups : null;
        !limitType ? delete eventData.component.AffLimitType : null;
        this.triggerEventWithData(null, eventData);
    }
    raiseEventForAffordabilityPaymentError(errorMessage: any) {
        const eventData = this.getEventData();
        const eventName = 'paymentError';
        eventData.payment.error = errorMessage;
        eventData.payment.source = 'betslip qd';
        eventData.payment.depositMethod = 'standard deposit';
        this.triggerEventWithData(eventName, eventData);
    }
    // when user got any banner/toaster Button clicks related to affordability
    raiseEventForAffordabilityButtons(
        labelevent: any,
        buttonName: any,
        positionEvent: any,
        urlClicked: any,
        level: any,
        affGroup: any,
        affAgeGroup: any,
        limitType: any,
    ) {
        const eventData = {
            event: 'Event.Affordability',
            component: {
                CategoryEvent: 'affordability',
                LabelEvent: labelevent,
                ActionEvent: 'click',
                PositionEvent: positionEvent,
                LocationEvent: 'quick deposit page',
                EventDetails: buttonName,
                URLClicked: urlClicked,
                AffordabilityJourney: level,
                AffordabilityGroups: affGroup?.toLowerCase(),
                AffAgeGroups: affAgeGroup?.toLowerCase(),
                AffLimitType: limitType,
            },
        };
        !affGroup ? delete eventData.component.AffordabilityGroups : null;
        !affAgeGroup ? delete eventData.component.AffAgeGroups : null;
        !limitType ? delete eventData.component.AffLimitType : null;
        this.triggerEventWithData(null, eventData);
    }
    //When user reached almost 80% of limit
    raiseEventForAffordabilitySuccessMsg(labelevent: any, percent: any, limit: any) {
        const eventData = this.getEventData();
        const eventName = 'contentView';
        eventData.component.CategoryEvent = 'affordability';
        eventData.component.LabelEvent = labelevent;
        eventData.component.ActionEvent = 'load';
        eventData.component.PositionEvent = 'user reached almost ' + percent + '% of limit hardstop monthly ' + limit + 'k';
        eventData.component.LocationEvent = 'quick deposit page';
        eventData.component.EventDetails = `hardstop monthly ${limit}k`;
        eventData.component.URLClicked = 'not applicable';
        this.triggerEventWithData(eventName, eventData);
    }
    raiseEventForAffordabilitySuccessMsgLinks(labelevent: any, percent: any, limit: any, eventDetails: any, url: any, level: any) {
        const eventData = this.getEventData();
        const eventName = 'contentView';
        eventData.component.CategoryEvent = 'affordability';
        eventData.component.LabelEvent = labelevent;
        eventData.component.ActionEvent = 'click';
        eventData.component.PositionEvent = 'user reached almost ' + percent + '% of limit hardstop monthly ' + limit + 'k';
        eventData.component.LocationEvent = 'quick deposit page';
        eventData.component.EventDetails = eventDetails;
        eventData.component.URLClicked = url;
        eventData.component.AffordabilityJourney = level;
        this.triggerEventWithData(eventName, eventData);
    }
    raiseEventForAffFRAMsgBannerLoadClick(
        labelEvent: any,
        actionEvent: any,
        positionEvent: any,
        eventDetails: any,
        url: any,
        level: any,
        ageGroup: string,
        limitType: string,
        affGroup: string,
    ) {
        const eventData = this.getEventData();
        const eventName = 'Event.Affordability';
        eventData.component.CategoryEvent = 'affordability';
        eventData.component.LabelEvent = labelEvent;
        eventData.component.ActionEvent = actionEvent;
        eventData.component.PositionEvent = positionEvent;
        eventData.component.LocationEvent = 'quick deposit page';
        eventData.component.EventDetails = eventDetails;
        eventData.component.URLClicked = url;
        eventData.component.AffordabilityJourney = level;
        eventData.component.AffAgeGroups = ageGroup?.toLowerCase();
        eventData.component.AffLimitType = limitType;
        eventData.component.AffordabilityGroups = affGroup?.toLowerCase();
        eventData.component.flowName = 'fra';
        !affGroup ? delete eventData.component.AffordabilityGroups : null;
        !ageGroup ? delete eventData.component.AffAgeGroups : null;
        !limitType ? delete eventData.component.AffLimitType : null;
        this.triggerEventWithData(eventName, eventData);
    }

    raiseEventForAffordabilityMsgBannerLoad(
        labelevent: any,
        positionEvent: any,
        eventDetails: any,
        level: any,
        affGroup: any,
        affAgeGroup: any,
        limitType: any,
    ) {
        const eventData = {
            event: 'Event.Affordability',
            component: {
                CategoryEvent: 'affordability',
                LabelEvent: labelevent,
                ActionEvent: 'load',
                PositionEvent: positionEvent,
                LocationEvent: 'quick deposit page',
                EventDetails: eventDetails,
                URLClicked: 'not applicable',
                AffordabilityJourney: level,
                AffordabilityGroups: affGroup?.toLowerCase(),
                AffAgeGroups: affAgeGroup?.toLowerCase(),
                AffLimitType: limitType,
            },
        };
        !affGroup ? delete eventData.component.AffordabilityGroups : null;
        !affAgeGroup ? delete eventData.component.AffAgeGroups : null;
        !limitType ? delete eventData.component.AffLimitType : null;
        this.triggerEventWithData(null, eventData);
    }

    raiseEventForAffordabilityNetLossDepositCapClick(level: any, url: any) {
        const eventData = this.getEventData();
        const eventName = 'Event.Affordability';
        eventData.component.CategoryEvent = 'affordability';
        eventData.component.LabelEvent = 'aff ltm limit';
        eventData.component.ActionEvent = 'click';
        eventData.component.PositionEvent = 'user approaching ltm limit banner';
        eventData.component.LocationEvent = 'quick deposit page';
        eventData.component.EventDetails = 'Loss Limit & Deposit Cap';
        eventData.component.URLClicked = url;
        eventData.component.AffordabilityJourney = level;
        this.triggerEventWithData(eventName, eventData);
    }

    // When the user clicks on deposit CTA
    raiseEventForDepositCTA() {
        const eventData: EventData = this.gtmEventData;
        const eventName = 'Event.Tracking';
        eventData.component.CategoryEvent = 'navigation';
        eventData.component.LabelEvent = 'deposit button';
        eventData.component.ActionEvent = 'click';
        eventData.component.PositionEvent = 'not applicable';
        eventData.component.LocationEvent = 'navigation';
        eventData.component.EventDetails = 'deposit';
        eventData.component.URLClicked = 'not applicable';
        this.triggerEventWithData(eventName, eventData);
    }
    // When the user clicks on deposit CTA Cashier Popup Screen Load
    raiseEventForDepositCTACashierPopupScreenLoad() {
        const eventData: EventData = this.gtmEventData;
        const eventName = 'contentView';
        eventData.component.CategoryEvent = 'cashier';
        eventData.component.LabelEvent = "'deposit process";
        eventData.component.ActionEvent = 'load';
        eventData.component.PositionEvent = 'not applicable';
        eventData.component.LocationEvent = 'navigation';
        eventData.component.EventDetails = 'quick deposit screen';
        eventData.component.URLClicked = 'not applicable';
        this.triggerEventWithData(eventName, eventData);
    }
    // When the user clicks on deposit CTA on quick deposit Screen Load
    raiseEventForDepositCTAquickDepositScreenLoad() {
        const eventData = this.getEventData();
        const eventName = 'Event.Tracking';
        eventData.component.CategoryEvent = 'cashier';
        eventData.component.LabelEvent = 'deposit process';
        eventData.component.ActionEvent = 'click';
        eventData.component.PositionEvent = 'not applicable';
        eventData.component.LocationEvent = 'quick deposit page';
        eventData.component.EventDetails = 'deposit cta';
        eventData.component.URLClicked = 'not applicable';
        this.triggerEventWithData(eventName, eventData);
    }
    getEventData() {
        return this.gtmEventData;
    }
    // When the user clicks on deposit CTA on Quick deposit Screen and sucessfully deposited
    raiseEventForDepositSuccessload(paymentMethod: any) {
        const eventData: any = { ...this.gtmEventData };
        const eventName = 'Event.Tracking';
        eventData.component.CategoryEvent = 'deposit success';
        eventData.component.LabelEvent = 'success';
        eventData.component.ActionEvent = 'load';
        eventData.component.PositionEvent = 'not applicable';
        eventData.component.LocationEvent = 'not applicable';
        eventData.component.EventDetails = 'deposit success';
        eventData.component.URLClicked = 'not applicable';
        eventData.payment.method = paymentMethod;
        this.triggerEventWithData(eventName, eventData);
    }

    raiseEventForUnusualDeposit(eventType: any, locationEvent: any, txnAmount: any) {
        const eventData = this.getEventData();
        let eventName;
        if (eventType === 'unusualDepositInteractionMessage') {
            eventName = 'contentView';
            eventData.component.CategoryEvent = 'cashier';
            eventData.component.LabelEvent = 'unusual deposit';
            eventData.component.ActionEvent = 'load';
            eventData.component.PositionEvent = 'not applicable';
            eventData.component.LocationEvent = locationEvent;
            eventData.component.EventDetails = 'unusual deposit notice';
            eventData.component.URLClicked = 'not applicable';
            eventData.component.Value = txnAmount;
        } else if (eventType === 'unusualDepositInterventionMessage') {
            eventName = 'contentView';
            eventData.component.CategoryEvent = 'cashier';
            eventData.component.LabelEvent = 'unusual deposit';
            eventData.component.ActionEvent = 'load';
            eventData.component.PositionEvent = 'not applicable';
            eventData.component.LocationEvent = locationEvent;
            eventData.component.EventDetails = 'temporary 24h deposit limits applied info message post success deposit';
            eventData.component.URLClicked = 'not applicable';
        } else if (eventType === 'continue') {
            eventName = 'Event.Tracking';
            eventData.component.CategoryEvent = 'cashier';
            eventData.component.LabelEvent = 'unusual deposit';
            eventData.component.ActionEvent = 'click';
            eventData.component.PositionEvent = 'continue';
            eventData.component.LocationEvent = locationEvent;
            eventData.component.EventDetails = 'unusual deposit notice';
            eventData.component.URLClicked = 'not applicable';
            eventData.component.Value = txnAmount;
        } else if (eventType === 'cancel') {
            eventName = 'Event.Tracking';
            eventData.component.CategoryEvent = 'cashier';
            eventData.component.LabelEvent = 'unusual deposit';
            eventData.component.ActionEvent = 'click';
            eventData.component.PositionEvent = 'cancel';
            eventData.component.LocationEvent = locationEvent;
            eventData.component.EventDetails = 'unusual deposit notice';
            eventData.component.URLClicked = 'not applicable';
            eventData.component.Value = txnAmount;
        } else if (eventType === 'interventionLiveChat') {
            eventName = 'Event.Tracking';
            eventData.component.CategoryEvent = 'cashier';
            eventData.component.LabelEvent = 'unusual deposit';
            eventData.component.ActionEvent = 'click';
            eventData.component.PositionEvent = 'live chat';
            eventData.component.LocationEvent = locationEvent;
            eventData.component.EventDetails = 'temporary 24h deposit limits applied info message post success deposit';
            eventData.component.URLClicked = 'not applicable';
            eventData.component.Value = txnAmount;
        }
        this.triggerEventWithData(eventName, eventData);
    }

    raiseEventForReversalSuccess(eventName: any, pageName: any) {
        const eventData = this.getEventData();
        eventData.payment.Source = pageName;
        this.triggerEventWithData(eventName, eventData);
    }
    raiseEventWithSource(eventName: any, pageName: any, paymentMethod: any, source: any) {
        const eventData: EventData = this.getEventData();
        eventData.payment.method = paymentMethod;
        eventData.payment.Source = source;
        const response = this.dataService.data;

        if (response) {
            if (eventName === 'deposit' && response.status === 'SUCCESS') {
                eventData.payment.txnAmount = response.amount || '';
                eventData.payment.txnCurrency = response.amount ? response.amount.currencyCode : '';
                eventData.payment.baseAmount = response.baseAmount ? response.baseAmount.value : '';
                eventData.payment.baseCurrency = response.baseAmount ? response.baseAmount.currencyCode : '';
                eventData.payment.lifeTimeDeposits = response.totalDepositCount ? response.totalDepositCount : '';
                eventData.payment.depositTransactionId = response.transactionId ? response.transactionId : '';
            } else if (eventName === 'paymentError' && (response.errorResponse || pageName === 'DepositDecline')) {
                eventData.payment.error = response.errorResponse ? response.errorResponse.errorMessage : '';
                eventData.payment.lifeTimeDeposits = response.totalDepositCount ? response.totalDepositCount : '';
            }

            if (eventName === 'paymentError' && response.kycCheckResponse && 'DEU' === response.kycCheckResponse.jurisdiction) {
                if (response.kycCheckResponse.productPreference === 'SPORTSBOOK') {
                    if (response.kycCheckResponse.errorResponse) {
                        if (response.kycCheckResponse.errorResponse.errorMessage === 'KYC_GRACEPERIOD_COMPLETED') {
                            eventData.payment.error = 'KYC unverified – grace period ended';
                        } else if (response.kycCheckResponse.errorResponse.errorMessage === 'KYC_LIMIT_EXCEEDED') {
                            eventData.payment.error = 'KYC unverified – 50k deposit limit amount exceeded';
                        }
                    }
                } else {
                    if (response.kycCheckResponse.errorResponse) {
                        if (response.kycCheckResponse.errorResponse.errorMessage === 'KYC_GRACEPERIOD_COMPLETED') {
                            eventData.payment.error = 'KYC unverified – grace period ended';
                        } else if (response.kycCheckResponse.errorResponse.errorMessage === 'KYC_LIMIT_EXCEEDED') {
                            eventData.payment.error = ' KYC partial verified – 150 EUR deposit limit amount exceeded';
                        }
                    }
                }
                if (
                    response.kycCheckResponse &&
                    response.kycCheckResponse.gbgVerified &&
                    response.kycCheckResponse.productPreference !== 'SPORTSBOOK'
                ) {
                    eventData.payment.error = 'KYC unverified – gaming verification required';
                }
            }
        }

        this.triggerEventWithData(eventName, eventData);
    }
    raiseActionEvent(eventName: any, actionName: any) {
        const eventData: EventData = this.gtmEventData;
        eventData.component.ActionEvent = actionName;
        this.triggerEventWithData(eventName, eventData);
    }

    raiseComponentEvent(eventName: any, data: any) {
        this.triggerEventWithData(eventName, data);
    }
    raiseFieldTrackingGTMEvent(actionEvent: any, positionEvent: any) {
        const eventData: EventData = this.gtmEventData;
        eventData.component.CategoryEvent = 'Cashier';
        eventData.component.LabelEvent = 'Field Tracking';
        eventData.component.ActionEvent = actionEvent;
        eventData.component.PositionEvent = positionEvent;
        eventData.component.LocationEvent = 'Betslip Quick Deposit';
        this.raiseComponentEvent('Event.Tracking', eventData);
    }
    raiseOnChangeAmtGTMEvent(action: any, position: any, amount: any) {
        const eventData: EventData = this.gtmEventData;
        eventData.component.CategoryEvent = 'Cashier';
        eventData.component.LabelEvent = 'Deposit Amount Selection';
        eventData.component.ActionEvent = action;
        eventData.component.PositionEvent = position;
        eventData.component.LocationEvent = 'Betslip Quick Deposit';
        eventData.component.EventDetails = amount;
        this.raiseComponentEvent('Event.Tracking', eventData);
    }
    raiseOnLoadGTMEvent() {
        const eventData: EventData = this.gtmEventData;
        eventData.component.CategoryEvent = 'Cashier';
        eventData.component.LabelEvent = 'Deposit Process';
        eventData.component.ActionEvent = 'Quick Deposit  - Loaded';
        eventData.component.PositionEvent = 'Cashier';
        eventData.component.LocationEvent = 'BetSlip';
        this.raiseComponentEvent('Event.Tracking', eventData);
    }
    raiseGTMComponentEvent(action: any) {
        const eventData: EventData = this.gtmEventData;
        eventData.component.CategoryEvent = 'Cashier';
        eventData.component.LabelEvent = 'Withdrawal Process';
        eventData.component.LocationEvent = 'BetSlip';
        eventData.component.ActionEvent = action;
        this.raiseComponentEvent('Event.Tracking', eventData);
    }
    intensivePlayerMsgLoad(paymentMethod: any, pageName: any) {
        const eventData: EventData = this.gtmEventData;
        const eventName = 'contentView';
        eventData.component.CategoryEvent = 'cashier';
        eventData.component.LabelEvent = 'forbidden deposit';
        eventData.component.ActionEvent = 'load';
        eventData.component.PositionEvent = paymentMethod;
        eventData.component.LocationEvent = pageName;
        eventData.component.EventDetails = 'credit card disabled message';
        eventData.component.URLClicked = 'not applicable';
        this.triggerEventWithData(eventName, eventData);
    }
    intensivePlayerMsgClickOnMoreInfo(pageName: any, clickUrl: any) {
        const eventData: EventData = this.gtmEventData;
        const eventName = 'Event.Tracking';
        eventData.component.CategoryEvent = 'cashier';
        eventData.component.LabelEvent = 'forbidden deposit';
        eventData.component.ActionEvent = 'click';
        eventData.component.PositionEvent = 'credit card disabled message ';
        eventData.component.LocationEvent = pageName;
        (eventData.component.EventDetails = 'more info'), (eventData.component.URLClicked = clickUrl);
        this.triggerEventWithData(eventName, eventData);
    }
    riskyPlayerAccountTempBlock(pageName: any) {
        const eventData = this.getEventData();
        const eventName = 'contentView';
        eventData.component.CategoryEvent = 'cashier';
        eventData.component.LabelEvent = 'forbidden deposit';
        eventData.component.ActionEvent = 'load';
        eventData.component.PositionEvent = 'not applicable';
        eventData.component.LocationEvent = pageName;
        (eventData.component.EventDetails = 'account restricted message'), (eventData.component.URLClicked = 'not applicable');
        this.triggerEventWithData(eventName, eventData);
    }
    riskyPlayerUnsuccessfulDep(pageName: any) {
        const eventData = this.getEventData();
        const eventName = 'contentView';
        eventData.component.CategoryEvent = 'cashier';
        eventData.component.LabelEvent = 'forbidden deposit';
        eventData.component.ActionEvent = 'load';
        eventData.component.PositionEvent = 'not applicable';
        eventData.component.LocationEvent = pageName;
        (eventData.component.EventDetails = 'deposit unsuccessful message'), (eventData.component.URLClicked = 'not applicable');
        this.triggerEventWithData(eventName, eventData);
    }
    riskyPlayerClickOnLiveChat(positionEvent: any, pageName: any, clickUrl: any) {
        const eventData = this.getEventData();
        const eventName = 'Event.Tracking';
        eventData.component.CategoryEvent = 'cashier';
        eventData.component.LabelEvent = 'forbidden deposit';
        eventData.component.ActionEvent = 'click';
        eventData.component.PositionEvent = positionEvent;
        eventData.component.LocationEvent = pageName;
        (eventData.component.EventDetails = 'live chat'), (eventData.component.URLClicked = clickUrl);
        this.triggerEventWithData(eventName, eventData);
    }
    // when user got any banner/toaster message loaded related to svoc max loss limits
    raiseEventForMaxLossLimitBannerLoad(isExceeded: any, level: any, affGroup: any, affAgeGroup: any, limitType: any) {
        const eventData = {
            event: 'contentView',
            component: {
                CategoryEvent: 'cashier',
                LabelEvent: 'svoc max loss limit',
                ActionEvent: 'load',
                PositionEvent: isExceeded ? 'user exhausted loss limit banner' : 'deposit crossing threshold banner',
                LocationEvent: 'quick deposit page',
                EventDetails: isExceeded ? 'user exhausted loss limit banner' : 'deposit crossing threshold banner',
                URLClicked: 'not applicable',
                AffordabilityJourney: level,
                AffordabilityGroups: affGroup?.toLowerCase(),
                AffAgeGroups: affAgeGroup?.toLowerCase(),
                AffLimitType: limitType,
            },
        };
        !affGroup ? delete eventData.component.AffordabilityGroups : null;
        !affAgeGroup ? delete eventData.component.AffAgeGroups : null;
        !limitType ? delete eventData.component.AffLimitType : null;
        this.triggerEventWithData(null, eventData);
    }

    raiseEventForMaxLossLimitClick(isExceeded: any, linkName: any, url: any, level: any, affGroup: any, affAgeGroup: any, limitType: any) {
        const eventData = {
            event: 'Event.Tracking',
            component: {
                CategoryEvent: 'cashier',
                LabelEvent: 'svoc max loss limit',
                ActionEvent: 'click',
                PositionEvent: isExceeded ? 'user exhausted loss limit banner' : 'deposit crossing threshold banner',
                LocationEvent: 'quick deposit page',
                EventDetails: linkName,
                URLClicked: url,
                AffordabilityJourney: level,
                AffordabilityGroups: affGroup?.toLowerCase(),
                AffAgeGroups: affAgeGroup?.toLowerCase(),
                AffLimitType: limitType,
            },
        };
        !affGroup ? delete eventData.component.AffordabilityGroups : null;
        !affAgeGroup ? delete eventData.component.AffAgeGroups : null;
        !limitType ? delete eventData.component.AffLimitType : null;
        this.triggerEventWithData(null, eventData);
    }
    raiseEventForProrg30daysLoad(positionEvent: any) {
        const eventData = {
            ...this.gtmEventData,
            eventName: 'contentView',
            component: {
                CategoryEvent: 'cashier',
                LabelEvent: 'deposit process',
                ActionEvent: 'load',
                PositionEvent: positionEvent,
                LocationEvent: 'quick deposit page',
                EventDetails: positionEvent,
                URLClicked: 'not applicable',
            },
        };
        this.triggerEventWithData(null, eventData);
    }
    raiseEventForProrg30daysClick(positionEvent: any, url: any, linkName: any) {
        const eventData = {
            ...this.gtmEventData,
            event: 'Event.Tracking',
            component: {
                CategoryEvent: 'cashier',
                LabelEvent: 'deposit process',
                ActionEvent: 'click',
                PositionEvent: positionEvent,
                LocationEvent: 'quick deposit page',
                EventDetails: linkName,
                URLClicked: url,
            },
        };
        this.triggerEventWithData(null, eventData);
    }
}
